const __WEBPACK_NAMESPACE_OBJECT__ = require("@francesc/basic-midi-player-js");